<template>
  <form id="id-new-recording-form">
    <ConveyRequiredStatement class="mb-2" />
    <p v-if="errors.length" class="text-danger">
      <b>Please correct the following error(s):</b>
      <ul>
        <li :key="error" v-for="error in errors">{{ error }}</li>
      </ul>
    </p>
    <div class="form-group pb-3">
      <div class="row">
        <label
          class="required-field-label"
          for="id-newrecording-target-number"
          style="float: left;"
        >
          Case Number
        </label>
      </div>
      <div class="row">
        <div class="col-12">
          <input
            v-model="caseNumber"
            id="id-caseNumber"
            type="text"
            placeholder="Enter Case Number"
            class="form-control bfh-phone"
            required
          >
        </div>
      </div>
    </div>
    <div class="form-group pb-3">
      <div class="row">
        <label
          class="required-field-label"
          for="id-newrecording-target-number"
          style="float: left;"
        >
          Audio File
        </label>
      </div>
      <div class="row">
        <div class="col-12">
          <input
            type="file"
            accept="audio/*"
            class="form-control col-md-6"
            id="audioFile"
            name="audioFile"
            placeholder="Audio File..."
            @input="pickFile"
            ref="fileInput"
          />
        </div>
      </div>
    </div>
    <div class="modal-footer bg-light stretch-footer ">
      <div class="text-right">
        <button
          type="button"
          class="btn btn-info btn-rounded"
          @click="validateForm"
          :disabled="!fileUploaded"
        >
          <span>Process Media</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { EventBus } from "../../events/eventBus";
import ConveyRequiredStatement from "@/components/ConveyRequiredStatement";

export default {
  name: "NewRecordingForm",
  components: { ConveyRequiredStatement },
  data() {
    return {
      errors: [],
      fileUploaded: false,
      httpPending: true,
      audioFile: null,
      caseNumber: null,
    };
  },
  computed: {
    ...mapGetters("agency", ["currentAgencyId", "agencySettings", "numbers"]),
    ...mapGetters("provider", ["providerImport"]),
    ...mapState({
      serverUrl: (state) => state.connection.serverUrl,
      wsOnly: (state) => state.connection.wsOnly,
      path: (state) => state.connection.path,
      namespace: (state) => state.connection.namespace,
      parser: (state) => state.connection.parser,
      currentUser: (state) => state.user.user,
      currentToken: (state) => state.user.token
    }),
    internationalDialCodeEnabled() {
      return this.agencySettings.enableInternational == "true";
    },
    sourceNumber: {
      get() {
        let sourceNumber = this.selectedSourceNumber;
        if (sourceNumber)
          return this.selectedSourceNumber;
        else if (this.$cookie.get("x-pref-sourcenumber")) {
          sourceNumber = this.numbers.filter((n) => n.number === this.$cookie.get("x-pref-sourcenumber"));
          if (sourceNumber)
            return sourceNumber;
        } else
          sourceNumber = this.numbers[0];

        return sourceNumber;
      },
      set(v) {
        this.selectedSourceNumber = v;
      }
    }
  },
  beforeDestroy() {
    EventBus.$off("fileUploadStatus");
  },
  methods: {
    ...mapActions("conversations", ["createConversation"]),
    async validateForm() {
      if (!this.caseNumber || (this.caseNumber && this.caseNumber.trim() === "")) {
        this.errors.push("Please specify a case number");
        return false;
      }

      this.errors = [];
      this.httpPending = true;

      const payload = {
        label: this.caseNumber,
        channel: "media",
        resource_file: this.audioFile,
      };

      try {
        const resp = await this.$ConveyApi.conversationsApi.createConversation({ payload });

        EventBus.$emit("close-modal");
        if (resp.status == 201) {
          this.$toastr("success", "Media Processing Started");
          this.createConversation(resp.data.data);
        } else
          this.$toastr("warning", "Showing active recording", "Active Recording Exists");

        this.$router.push({ path: `/conversations/${resp.data.data.conversation_id}` }).catch(() => { });
        this.httpPending = false;

        return true;
      } catch (error) {
        this.errors.push(error.response.data.data.error);
        this.$toastr("error", "Error Processing Recording (" + error.response.status + ")");
        this.httpPending = false;
        return false;
      }
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let files = input.files;
      function filePrefix() {
        return "xxxxx".replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == "x" ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      }

      if (files && files[0]) {
        let reader = new FileReader;
        reader.onload = e => {
          this.logoPreview = e.target.result;
        };

        reader.readAsDataURL(files[0]);
        EventBus.$emit("fileUpload", files[0], `media/${this.currentAgencyId}/${filePrefix()}-${files[0].name}`, files[0].type);
      }
    },
    initFocus() {
      const $ = window.$;
      setTimeout(function () {
        $("#id-caseNumber").focus();
      }, 250);
    }
  },
  mounted() {
    this.$nextTick(() => this.initFocus());
    EventBus.$on("fileUploadStatus", (status, result) => {
      if (status === true) {
        /* eslint-disable */
        console.log(`*** fileUploadStatus ${result}`);
        this.audioFile = result;
        this.fileUploaded = true;
        this.settingsUpdated = true;
      }
    });
  },
  created() {
    this.httpPending = false;
    EventBus.$on("actionButton-click", () => {
      this.validateForm();
    });
  }
};
</script>

<style scoped>
.stretch-footer {
  margin-left: -16px;
  margin-right: -16px;
  margin-bottom: -16px;
}
</style>
